import React from 'react'
import { ButtonType } from '../../../components/GenericButton/styles'
import { Typography } from '@mui/material'
import { useAppDispatch } from '../../../store'
import { grey } from '../../../colors'
import { type ISurveyRow } from '../types'
import { deleteSurveyTemplateApi } from '../../../store/slices/SurveySlice/apis'
import { deleteLoading } from '../../../store/slices/SurveySlice/selectors'
import { useTheme } from '@mui/material/styles'
import DefaultModalActions from '../../../components/GenericModal/DefaultModalActions'
import { type ApiError } from '../../../models/Common'
import { notification } from '../../../components/Notifications'

interface DeleteSurveyTemplateProps {
  selectedRow?: ISurveyRow
  handleCloseModal?: () => void
  showErrorModal?: () => void
  setErrorMessage?: (arg: string) => void
}

const DeleteSurveyTemplate: React.FC<DeleteSurveyTemplateProps> = ({ selectedRow, handleCloseModal, showErrorModal, setErrorMessage }) => {
  const dispatch = useAppDispatch()
  const isDeleteLoading = deleteLoading()
  const theme = useTheme()

  const handleDelete = async (): Promise<void> => {
    try {
      await dispatch(deleteSurveyTemplateApi({ urlId: selectedRow?.templateId })).unwrap()
      handleCloseModal?.()
    } catch (error) {
      const customError = error as ApiError
      if (customError && customError.status === 422) {
        setErrorMessage?.(customError.message || 'Unknown error')
        showErrorModal?.()
        return
      }
      notification(customError?.message ?? 'Internal server error', { variant: 'error' })
    }
  }

  return (
    <>
      <Typography fontSize='14px' lineHeight={theme.spacing(5)} color={grey[850]}>
        You will not be able to recover this Survey Template. All references to it will be deleted.
      </Typography>
      <DefaultModalActions
        confirmButtonProps={{
          onClick: handleDelete,
          text: 'Delete',
          loading: isDeleteLoading,
          buttonType: ButtonType.Destructive
        }}
        destructiveButtonProps={{
          onClick: handleCloseModal
        }}
      />
    </>

  )
}

export default DeleteSurveyTemplate
